import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IInverterList } from '../models/inverter';

@Injectable({
  providedIn: 'root',
})
export class Inverter {
  private baseUrl: string = `${environment.apiUrl}/inverter`;
  private http: HttpClient = inject(HttpClient);

  //signals for state
  inverters = signal<IInverterList[]>([]);
  isLoading = signal(false);
  errorMessage = signal('');

  getInverterList(controllerId: number): void {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.http
      .get<IInverterList[]>(`${this.baseUrl}/controller/${controllerId}`)
      .subscribe({
        next: (data) => {
          this.inverters.set(data);
          this.isLoading.set(false);
        },
        error: (err) => {
          console.error(err);
          this.errorMessage.set('Failed to load controllers.');
          this.isLoading.set(false);
        },
      });
  }

  updateFromSocket(data: IInverterList[]) {
    this.inverters.set(data);
  }
}
